import { get } from "lodash-es";

export default {
  namespaced: true,
  state: () => ({
    dominioAnterior: "",
    patenteAnterior: "",
    fechaAlta: "",
    tipoContrato: null,
    empresa: null,
    subfactura: null,
    empresaPropia: null,
    idContratoMantenimiento: null,
    fechaInicio: null,
    fechaFin: null,
    porcentajeDescuento: 50,
    notas: null,
    idCliente: null,
    avl: null,
    imei: null,
    nombreWeb: "",
    ubicacionAvl: "",
  }),
  mutations: {
    reset(state) {
      state.dominioAnterior = "";
      state.patenteAnterior = "";
      state.fechaAlta = "";
      state.tipoContrato = null;
      state.empresa = null;
      state.subfactura = null;
      state.empresaPropia = null;
      state.avl = null;
    },
    inicializarContrato(state, payload) {
      state.dominioAnterior = get(payload, "dominio", "SIN_DOMINIO");
      state.fechaAlta = get(payload, "fecha_alta", "SIN FECHA");
      state.patenteAnterior = get(payload, "patente", "SIN_PATENTE");
      state.tipoContrato = get(payload, "id_contrato_tipos", null);
      let empresaPropia = payload.id_empresas_propias;
      if (empresaPropia === null) empresaPropia = 0;
      state.empresaPropia = empresaPropia;
      state.empresa = get(payload, "id_empresa", null);
      state.subfactura = get(payload, "subfactura", null);
      state.avl = get(payload, "id_avl", "NO_SE_ENCONTRO_AVL");
      state.idContratoMantenimiento = get(
        payload,
        "id_contrato_mantenimiento",
        null,
      );
      state.fechaInicio = get(payload, "fecha_inicio", null);
      state.fechaFin = get(payload, "fecha_fin", null);
      state.porcentajeDescuento = get(payload, "porcentaje_descuento", 50);
      state.notas = get(payload, "notas", null);
      state.imei = get(payload, "imei", null);
      state.ubicacionAvl = get(payload, "ubicacion", "");
    },
    setNombreWeb(state, payload) {
      state.nombreWeb = payload;
    },
    setTipoContrato(state, payload) {
      state.tipoContrato = payload;
    },
    setIdCliente(state, payload) {
      state.idCliente = payload;
    },
    setFechaAlta(state, payload) {
      state.fechaAlta = payload;
    },
    setEmpresaPropia(state, payload) {
      state.empresaPropia = payload;
    },
    setEmpresa(state, payload) {
      state.empresa = payload;
    },
    setSubfactura(state, payload) {
      state.subfactura = payload;
    },
    setNotas(state, payload) {
      state.notas = payload;
    },
    setFechaInicio(state, payload) {
      state.fechaInicio = payload;
    },
    setFechaFin(state, payload) {
      state.fechaFin = payload;
    },
    setPorcentajeDescuento(state, payload) {
      state.porcentajeDescuento = payload;
    },
    setImei(state, payload) {
      state.imei = payload;
    },
    setUbicacionAvl(state, payload) {
      state.ubicacionAvl = payload;
    },
  },
  actions: {},
};
